import { Box, CircularProgress } from "@mui/material";

const LoadingScreen = () => (
  <Box
    sx={{
      position: "fixed",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      svg: {
        color: "brightBlue.main",
      },
      bgcolor: "background.paper",
      zIndex: 99999999999999,
      inset: 0,
      marginBlockStart: "0 !important",
    }}
    data-ignore-max-width="strict"
  >
    <CircularProgress size="100px" />
  </Box>
);

export default LoadingScreen;
